"use strict";
exports.__esModule = true;
exports.CREDIT_BUILDER_HOW_FLEX_WORKS_CONTENT = void 0;
var BULLETS = [
    {
        HEADER: 'Make your rent payment',
        BODY: 'Flex will automatically transfer your rent payment to your property and ensure it arrives on time.'
    },
    {
        HEADER: 'Flex sends credit-building reports',
        BODY: 'Flex will report your credit line usage and on-time payment history to the credit bureaus.'
    },
    {
        HEADER: 'Watch your credit improve!',
        BODY: 'You’ll build your credit every time you use Flex to pay rent.'
    },
];
exports.CREDIT_BUILDER_HOW_FLEX_WORKS_CONTENT = {
    HEADER: 'How to build credit with Flex',
    CTA: 'Review schedule',
    BULLETS: BULLETS
};
